import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Reoverlay} from "reoverlay";
import Button from "../components/Button";
import BottomButtonWrapper from "../components/BottomButtonWrapper";
import AccessImage from "../images/access.png";
import {divarLinkGenerator, safeRedirect} from "../tools/helpers";
import ErrorModal from "../components/modals/ErrorModal";

const DefaultValues = {
    "v11dW62X4kaZ2Hn4": {
        //divar
        CService: {
            theme: "blue",
            title: 'تایید اصالت خودرو',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند تایید اصالت خودرو نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل تایید اصالت خودرو را انجام دهید.',
            image: AccessImage,
            accessButton: "شروع فرایند ",
        },
        IAuth: {
            theme: "green",
            image: AccessImage,
            title: 'احراز هویت ',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند تایید چهره نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل احراز هویت را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        OriginalityDevice: {
            theme: "green",
            image: AccessImage,
            title: 'تایید اصالت موبایل و تبلت',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        TransactionalCredit: {
            theme: "green",
            image: AccessImage,
            title: 'تایید اعتبار معاملاتی',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        Authentication: {
            theme: "green",
            image: AccessImage,
            title: 'احراز هویت',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل احراز هویت را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        CompanyApproval:{
            theme: "green",
            image: AccessImage,
            title: 'احراز هویت حقوقی ونیفای',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل احراز هویت را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        BusinessLicenseInquiry: {
            theme: "green",
            image: AccessImage,
            title: 'احراز هویت',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        DivarInternalAuth: {
            theme: "green",
            image: AccessImage,
            title: 'احراز هویت',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        DivarInternalEstate: {
            theme: "green",
            image: AccessImage,
            title: 'تایید ملک',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        FinCheck: {
            theme: "green",
            image: AccessImage,
            title: 'خوش حسابی بانکی',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        PoliceClearance: {
            theme: "green",
            image: AccessImage,
            title: 'تایید عدم سو پیشینه',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        Estate: {
            theme: "green",
            image: AccessImage,
            title: 'تایید ملک',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        ForeignerAuth: {
            theme: "green",
            image: AccessImage,
            title: 'احراز هویت',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        },
        DivarInternalCar: {
            theme: "green",
            image: AccessImage,
            title: 'احراز اصالت خودرو',
            errorMessage: 'خطای دسترسی ',
            errorDetail: 'برای ادامه فرایند نیاز به دسترسی دیوار می‌باشد. با کلیک بر روی دکمه شروع فرایند می‌توانید ادامه مراحل  را انجام دهید.',
            accessButton: "شروع فرایند",
        }
    }
}
const StartAuth = () => {

    const {id, service} = useParams();
    const [searchParams]=useSearchParams();

    const ticketUuid=searchParams.get('ticket_uuid');
    const postToken=searchParams.get('post_token');
    const returnUrl=searchParams.get('return_url');
    const hasPostAddon=searchParams.get('has_post_addon');
    const hasUserAddon=searchParams.get('has_user_addon');

    const navigate = useNavigate();
    if (!id || !service) {
        navigate('Failed')
    }
    function toQueryParams(obj) {
        return Object.keys(obj)
            .filter(key => obj[key] !== null && obj[key] !== undefined) // Exclude null and undefined
            .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
            .join('&');
    }
    const handleBackToDivar = () => {
        const link=divarLinkGenerator({
            returnUrl: sessionStorage.getItem('return_url')
        });
        safeRedirect(link,()=>{
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: 'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText: 'بستن',
                onCancel: () => {
                    Reoverlay.hideModal();
                    navigate('/404')
                }
            })
        })
    }
    const handleRedirect=()=>{
        const params = {
            "post_token": postToken ? postToken : null,
            "return_url": returnUrl ? returnUrl : null,
            "ticket_uuid": (ticketUuid && !ticketUuid.startsWith('vm_')) ? ticketUuid : null,
            "has_post_addon": hasPostAddon ? hasPostAddon : null,
            "has_user_addon": hasUserAddon ? hasUserAddon : null,
        }
        const queryParams = toQueryParams(params);
        navigate(`/auth/gate/${id}/${service}?${queryParams}`)
    }
    return <div className="w-full flex justify-center p-5 ">
        <div className="w-full bg-white  p-5  flex flex-col items-center justify-center rounded-xl lg:w-3/12">
            <img className="w-8/12 mb-5 mt-3 h-auto" src={DefaultValues[id][service].image} alt=""/>
            <div className="p-3 flex justify-center items-center flex-col  w-full  rounded-lg">
                <h1 className="text-lg text-red-600 font-bold"> {DefaultValues[id][service].errorMessage}</h1>
                <p className="text-sm text-gray-600  font-light text-center mt-3 ">
                    {DefaultValues[id][service].errorDetail}
                </p>
            </div>
            <BottomButtonWrapper grid={2}>
                <Button onClick={handleBackToDivar} className="w-full " rounded="rounded-lg"
                        theme="link">بازگشت </Button>
                <Button onClick={handleRedirect} className="w-full" rounded="rounded-lg" theme={DefaultValues[id][service].theme}>{DefaultValues[id][service].accessButton}</Button>

            </BottomButtonWrapper>
        </div>
    </div>
}
export default StartAuth;